import type { ComponentChildren } from 'preact'

import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { DialogHeader } from '#src/assets/ui/shared/components/DialogHeader.tsx'

export function SettingsDialogHeader({
  t,
  children,
}: {
  t: CookieConsentTranslator
  children: ComponentChildren
}) {
  return (
    <DialogHeader
      className="lcc-settings-dialog__header"
      titleClassName="lcc-settings-dialog__title"
      title={t('cookieSettingsTitle')}
    >
      {children}
    </DialogHeader>
  )
}
